module.exports = __webpack_public_path__ + "media/images/pro_subscription/carousel3-haircut-en-GB-2848bd7d7ae4aec7c955b39b86eb0639.png";